import React, {useState, useEffect, useRef} from "react";
import WebFont from 'webfontloader';
import './header.scss';
import {ReactComponent as SVGBinusWaffle} from './../../assets/nine-dots.svg';
import {ReactComponent as SVGSearch} from './../../assets/search.svg';
import {ReactComponent as SVGNotif} from '../../assets/notif.svg';
import {ReactComponent as SVGClose} from '../../assets/close.svg';
import fancybox, { popinfo } from '../Fancybox/Fancybox';
import LoginBox, { RefreshAzureToken, formatLoginError } from "../../component/LoginBox/LoginBox";
import UserState from "../../store/stateMap";
import { MSGraphAuthenticator } from '../../msal';
import { NotifList } from "component/Notif";
import api from '../../api';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {  SetUser, SetTokenizeUser, SetLookingUser, setUserNotif, SetInitiativeAccess } from "../../store/dispatcher";
import { usePopper } from "react-popper";
import { AvatarGetPicture } from "component/Avatar";
import InitialsAvatar from 'react-initials-avatar';
import { useSearchParams } from "react-router-dom";
import { CallLoginInteraction } from "component/LoginBox/LoginBox";
import { parsePath } from "history";
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import store from "store/store";
import _ from "lodash";
import "animate.css/animate.css";


export default connect(UserState, { SetTokenizeUser, SetLookingUser, SetUser, setUserNotif, SetInitiativeAccess } )((props) => {

    const [headerBG, setHeaderBG] = useState(props.background);
    let [searchParams]              = useSearchParams();
    const queryString                                       = new URLSearchParams(parsePath(window.location.href).search || '');
    const profileWrapper                                            = useRef(null);
    const profilePopWrapper                                         = useRef(null);
    const [showProfilePopper, setShowProfilePopper]                 = useState(false);
    const [profileReferenceElement, setProfileReferenceElement]     = useState(null);
    const [profilePopperElement, setProfilePopperElement]           = useState(null);
    const profileStyles = usePopper(profileReferenceElement, profilePopperElement, {
        placement : 'bottom-end'
    });

    const notifWrapper                                          = useRef(null);
    const notifPopWrapper                                       = useRef(null);
    const [showNotifPopper, setShowNotifPopper]                 = useState(false);
    const [notifReferenceElement, setNotifReferenceElement]     = useState(null);
    const [notifPopperElement, setNotifPopperElement]           = useState(null);
    const notifStyles = usePopper(notifReferenceElement, notifPopperElement, {
        placement : 'bottom-end'
    });

    const [showWafflePopper, setShowWafflePopper]                = useState(false);
    const [userApps, setUserApps]                                   = useState(false);
    const [incompleteProjects, setIncompleteProjects]               = useState(0);

    const glanceNotifs = () => {
        props.setUserNotif(0);

        api('/Notif/GlanceAll', 'post', {}, 'Bearer ' + props.auth.token);
    }


    const BodyClick = (e) => {
        if (
            profileWrapper.current && !profileWrapper.current.contains(e.target) 
            &&
            profilePopWrapper.current && !profilePopWrapper.current.parentNode.contains(e.target) 
        ) 
        {
            setShowProfilePopper(false);
        }
        if (
            notifWrapper.current && !notifWrapper.current.contains(e.target) 
            && 
            notifPopWrapper.current && !notifPopWrapper.current.parentNode.contains(e.target)) 
        {
            setShowNotifPopper(false);
        }
    }

    useEffect(() => {
        WebFont.load({
            google: {
              families: ['Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,600;1,700']
            }
        });

        if(queryString.get('token') !== null)
        {   
            // Validating Query String
            let loaderBox = popinfo('loader', 'Validating Session', 'Wait a sec...');

            api('/Account/ValidateSSO', 'post', {
                token : queryString.get('token')
            })
                .then(response => {
                    loaderBox.close();

                    if(response.user)
                    {
                        store.dispatch({
                            type: 'auth/setUser'
                            ,payload: queryString.get('token')
                        });
                    }
                    else
                    {
                        popinfo('error', 'Validation Session', 'Invalid user found', {}, loaderBox);
                    }
                    window.location.href = window.location.origin + window.location.pathname;
                })
                .catch(error => {
                    window.location.href = window.location.origin + window.location.pathname;
                })



        }
        else if(props.auth.token)
        {
            props.SetLookingUser(true);

            api('/Account/Token', 'post', {
                token : props.auth.token
            })
                .then(function(response){
                    if(response.user.Expires.expired || response.user.Expires.expiring)
                    {
                        let Authenticator = new MSGraphAuthenticator();

                        Authenticator.getToken()
                            .then((response => {

                                RefreshAzureToken(response.accessToken, response.expiresOn.getTime() / 1000)
                                    .then(function(CrowdbeesToken){
                                        
                                        api('/Account/Token', 'post', {
                                            token : CrowdbeesToken.user.AccessToken
                                        })
                                            .then(function(ResponseToken){
                                                props.SetLookingUser(false);
                                                
                                                props.SetTokenizeUser(ResponseToken.user);
                                            });

                                    })
                                    .catch(function(){
                                        props.SetLookingUser(false);

                                        props.SetTokenizeUser(false);
                                    })                                
                            })).catch(error => {
                                popinfo('error', 'Crowdbees Session Expires', '<span style="max-width:600px;display:block">'+formatLoginError(error)+'</span>' );

                                props.SetUser('');

                                props.SetLookingUser(false);

                                props.SetTokenizeUser(false);
                            });
                    }
                    else
                    {
                        props.SetLookingUser(false);
    
                        props.SetTokenizeUser(response.user);
                    }
                })
        }
        else
        {
            if(searchParams.get('force-login') !== null)
            {
                let loaderBox = popinfo('loader', 'Logging You In', 'Wait a sec...');

                CallLoginInteraction()
                    .then((user) => {
                        loaderBox.close();
                        
                        props.SetTokenizeUser(user);
                    })
                    .catch(err => {
                        popinfo('error', 'Logging You In', formatLoginError(err), null, loaderBox);

                        props.SetUser('');

                        props.SetLookingUser(false);

                        props.SetTokenizeUser(false);
                    })
            }
            props.SetLookingUser(false);
        }

    },[])


    useEffect(() => {
        if(props.auth.user)
        {
            api('/Profile/UnGlanced', 'get', {}, 'Bearer ' + props.auth.token)
                .then(response => {
                    props.setUserNotif(response.unglanced)
                })
        }
    }, [props.auth.user]);

    useEffect(() => {
        document.addEventListener('click', BodyClick, true);
        return () => {
            document.removeEventListener('click', BodyClick, true);
        }
    },[]);

    useEffect(() => {
        setHeaderBG(props.background);
    }, [props.background]);

    useEffect(() => {
        if(!showWafflePopper)
        {
            return;
        }
        if(!props.auth.user)
        {
            return;
        }

        if( !_.isArray(userApps))
        {
            setUserApps(false);

            api('/UserApps', 'get', {}, 'Bearer ' + props.auth.token)
                .then(response => {
                    setUserApps(response.apps);
                })
                .catch(error => {
                    setUserApps(error)
                })
        }

    }, [showWafflePopper, props.auth.user])

    useEffect(() => {
        if(props.auth.user)
        {
            api('/Initiative', 'get', {
                incomplete : 1, get_total : 1,member_id : props.auth.user.UserID
            }).then(response => {
                setIncompleteProjects(response.initiative.length > 0 ? '1+' : 0)
            })

        }
    },[props.auth.user])

    return (
        <header id="app-header">
            <div className="black-bar">
                <div className="container">
                    <a href="#" className="binus-waffle" onClick={e => {
                        e.preventDefault();
                        setShowWafflePopper(true)
                    }}>
                        <SVGBinusWaffle className="binus-universe-app"/>
                    </a>
                </div>
            </div>
            <div className="brand-area">
                <div className="header-bg" style={
                    headerBG ?
                    {backgroundImage : `url(${headerBG})`, opacity : 1} :
                    {opacity : 0}
                }/>

                <div className="container brand-area-wrapper">
                    <div>
                        <Link to="/" className="image-box crowdbees-logo">
                            <img src={process.env.PUBLIC_URL + '/logo-blue.svg'} alt="" />    
                        </Link> 
                    </div>
                    <form className="search-container" action= {`${props.config.base_url}/search`}>
                        <SVGSearch/>
                        <input type="text" className="search-crowdbees" name="s" placeholder="Search Crowdbees..."/>
                    </form>
                    <div className="control-area">
                        <div className="text-center">
                            <Link to="/faq">FAQ</Link>
                        </div>
                        <div>
                            {
                                !props.auth.fetching && !props.auth.user &&
                                <button 
                                    className="btn btn-reverse btn-primary btn-small btn-login"
                                    onClick={() => {
                                        fancybox(<LoginBox/>);
                                    }}
                                >Login</button>
                            }
                            {
                                !props.auth.fetching && props.auth.user &&
                                <div className="user-header-bar">
                                    <button className="view-notif" style={{
                                        marginTop : '3px'
                                    }} ref={notifWrapper} onClick={() => {
                                        setShowNotifPopper(!showNotifPopper);

                                        glanceNotifs();

                                    }}>
                                        <SVGNotif ref={setNotifReferenceElement}/>
                                        {
                                            props.auth.notif > 0 && <span className="unglanced-notif">{props.auth.notif}</span>
                                        }
                                    </button>
                                    <button className="view-profile" ref={profileWrapper} onClick={() => {
                                        setShowProfilePopper(!showProfilePopper);
                                    }}>
                                        <div className="image-box circle square" ref={setProfileReferenceElement}>
                                            {
                                                !props.auth.user.UserPhoto ? <InitialsAvatar name={props.auth.user.UserDisplayName}  /> 
                                                : <img src={AvatarGetPicture(props.auth.user)} alt={ props.auth.user.UserDisplayName } />
                                            }
                                        </div>
                                    </button>
                                    <Link className="view-incomplete" to={incompleteProjects === 0 ? '/create' : '/profile/initiative'}>
                                        {incompleteProjects === 0 ? '+' : incompleteProjects}
                                    </Link>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {props.children}
            </div>
            {
                showWafflePopper && 
                <div className="semesta-apps-container" >
                    <div className="black-layer" onClick={() => {
                        setShowWafflePopper(false);
                    }}></div>
                    <div className="semesta-apps-wrapper">
                        <div className="pop-actions">
                            <a href="#" className="close-semesta" onClick={(e) => {
                                e.preventDefault();

                                setShowWafflePopper(false);
                            }} ><SVGClose/></a>
                            <span className="semesta-title">Apps</span>
                        </div>
                        {
                            props.auth.user ? 
                            <div className="pop-infos">
                                <ul className="semesta-apps">
                                    {
                                        userApps !== false && _.isArray(userApps) && userApps.map(app => (
                                            app.webUrl &&
                                            <li className="semesta-app">
                                                <a href={app.webUrl} className="wrapper" target="_blank">
                                                    <span className="app-icon image-box square contain">
                                                        <img src={app.iconUrl} alt=""/>
                                                    </span>
                                                    <span className="app-title">{app.appName}</span>
                                                </a>
                                            </li>
                                        ))
                                    }
                                    {
                                        userApps !== false && !_.isArray(userApps) &&
                                        <li className="semesta-app">
                                            <span className="text-xs color-red">{userApps}</span>
                                        </li>
                                    }
                                    {
                                        userApps === false &&
                                        <li className="semesta-app">
                                            <span className="wrapper">
                                                <span className="skeleton"></span>
                                            </span>
                                        </li>
                                    }
                                    
                                </ul>
                            </div>
                            :
                            <div className="">
                                <span className="text-xs bold">Login to see your list apps</span>
                                <hr />
                                <LoginBox/>
                            </div> 
                        }
                    </div>
                </div>
            }
            {
                showProfilePopper && 
                <div className="header-pop curent-user-pop" ref={setProfilePopperElement} style={ profileStyles.styles.popper }>
                    <div className="wrapper" ref={ profilePopWrapper}>
                        <button className="close-button" onClick={() => {
                            setShowProfilePopper(false);
                        }}>
                            <SVGClose/>
                        </button>
                        <div className="flex flex-wrap">
                            <div>
                                <span className="image-box circle square">
                                    {
                                        !props.auth.user.UserPhoto ? <InitialsAvatar name={props.auth.user.UserDisplayName} /> 
                                        : <img src={AvatarGetPicture(props.auth.user)} alt={ props.auth.user.UserDisplayName } />
                                    }
                                </span>
                            </div>
                            <div>
                                <h4 className="block bold leading-text">{props.auth.user.UserDisplayName}</h4>
                                <span className="text-sm block">{props.auth.user.UserEmail}</span>
                                <div className="mt-md text-xs ">
                                    <Link to='/profile' className="color-brand block mb-sm" >VIEW PROFILE</Link>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <Link to='/create' className="text-center block mb-md text-sm" >Create an Initiative</Link>
                        {
                            props.auth.user.UserEmail.indexOf('@binus.edu') > 0 &&
                            <Link to='/group/create' className="text-center block mb-md text-sm" >Create a Page</Link>
                        }
                        <Link to='/profile/update' className="text-center block mb-md text-sm" >Edit Profile</Link>
                        <Link to='/messaging' className="text-center block mb-md text-sm" >Messages</Link>
                        <Link to='/profile/configuration' className="text-center block mb-md text-sm" >Configuration</Link>
                        <button className="btn btn-primary btn-block" onClick={(e) => {
                            e.preventDefault();
                            props.SetUser('');
                            props.SetTokenizeUser('');
                            props.SetInitiativeAccess(false);
                            setShowProfilePopper(false);
                            setShowNotifPopper(false);
                        }}>Logout</button>
                    </div>
                </div>
            }
            {
                showNotifPopper && 
                <div className="header-pop notif-pop" ref={setNotifPopperElement} style={ notifStyles.styles.popper }>
                    <div className="wrapper" ref={notifPopWrapper}>
                        <button className="close-button" onClick={() => {
                            setShowNotifPopper(false);
                        }}>
                            <SVGClose/>
                        </button>
                        <h4 className="bold">Notifications</h4>
                        <hr />
                        
                        <NotifList listArgs={{
                            posts_per_page : 5
                            ,paged : 1
                        }}/>
                        <hr />
                        <div className="text-right">
                            <Link className="text-xs color-brand" to="/notification">View All Notification</Link>
                        </div>
                    </div>
                </div>
            }
            {
            props.auth.fetching && <div className="crowdbees-preloader inset">
                    <div className="flex flex-wrap">
                        <div>
                            <img
                                className="animate__animated animate__infinite animate__bounce animate__slow"
                                src={`${process.env.PUBLIC_URL}/assets/image/logo-crowdbees-orange.png`} alt="" />
                        </div>
                    </div>
                </div>
            }
        </header>
    )
})